import React from 'react'

import './index.scss'
import iconServiceOn from '../../../../../assets/images/icon_service_on.svg'

export default props => {

  const {
    icon,
    active,
  } = props

  return (
    <div className="overview-channel-icon float-left">
      <img className="icon" src={icon} alt=""/>
      <img className="active" hidden={!active} src={iconServiceOn} alt=""/>
    </div>
  )

}
